<template>
  <div class="agent-list-container">
    <agent-box
      v-for="agent in agents"
      :agent="agent"
      :key="agent.emp_id"
      :selectedDistricts="selectedDistricts"
      @showPopup="showPopup"
    />
  </div>
</template>

<script>
import AgentBox from '@/components/Agent/ListItemBox';

export default {
  props: ['agents', 'selectedDistricts'],
  components: {
    AgentBox,
  },
  methods: {
    showPopup(url) {
      this.$emit('showPopup', url);
    },
  },
};
</script>

<style scoped>
.agent-list-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .agent-list-container {
    flex-wrap: wrap;
    flex-direction: row;
    margin: -12px;
    gap: 0;
  }
  .agent-list-container > div {
    padding: 12px;
    flex: 0 50%;
  }
}

/* desktop */
@media (min-width: 1200px) {
  .agent-list-container {
    flex-wrap: wrap;
    flex-direction: row;
    margin: -12px;
    gap: 0;
  }
  .agent-list-container > div {
    padding: 12px;
    flex: 0 33.3%;
  }
}
</style>
